var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"focus:outline-none",on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('icon',{staticClass:"text-primary",attrs:{"icon":_vm.iconName,"size":_vm.iconSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }